import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Button, theme } from '@frameio/vapor';
import { crossFade } from '../animations';
import type { RefreshChipButtonProps } from '../types';

type CopyContainerProps = {
  $marginLeft?: string;
};

const CountContainer = styled.div`
  height: 100%;
  position: relative;
`;

const Count = styled(motion.div)`
  left: 0;
  position: absolute;
  top: 0;
`;

const CopyContainer = styled.span<CopyContainerProps>`
  margin-left: ${({ $marginLeft }) => $marginLeft};
`;

function getMarginLeftStyle(count) {
  if (count === 2) {
    return theme.spaces[12];
  }
  if (count >= 10 && count < 100) {
    return '18px';
  }
  if (count >= 100) {
    return '28px';
  }
  return theme.spaces[12];
}

function formatCount(count) {
  if (count > 99) {
    return '99+';
  }
  return count;
}

export function RefreshChipButton({
  copy,
  count,
  dataTestId,
  iconAfter,
  iconBefore,
  label,
  onClick,
  size,
}: RefreshChipButtonProps) {
  const marginLeft = getMarginLeftStyle(count);

  return (
    <Button
      aria-label={label}
      color="primary"
      data-testid={dataTestId}
      iconAfter={iconAfter ?? null}
      iconBefore={iconBefore ?? null}
      onClick={onClick}
      size={size}
      style={{ borderRadius: theme.radii[16], width: '100%' }}
    >
      <CountContainer>
        <Count {...crossFade} key={`count-${formatCount(count)}`}>
          {formatCount(count)}
        </Count>
      </CountContainer>
      <CopyContainer $marginLeft={marginLeft}> {copy}</CopyContainer>
    </Button>
  );
}
